import React from 'react';
import Web3 from 'web3';
import BigNumber from 'bignumber.js';

class EnterGame extends React.Component {
    state = {
        contract: null,
        account: '',
        amount: '',
        costPerEntry: '',
        maxAllowedEntries: '',
        currentEntries: '',
        gameStarted: '',
    };

    componentDidMount = async () => {
        await this.initializeBlockchainData();
        this.intervalId2 = setInterval(this.initializeBlockchainData,5000);// Refresh every second
   
    }

    componentWillUnmount() {
        clearInterval(this.intervalId1); // Clear the interval when the component unmounts
        clearInterval(this.intervalId2); // Clear the interval when the component unmounts
    }

    initializeBlockchainData = async () => {
        // connect to MetaMask and set the provider
        const { web3 } = this.props;

        if (!web3) {
            console.error("Web3 is not available. Please connect your wallet or install a Dapp browser.");
            return;  // Return early if web3 is not available
        }
        const accounts = await web3.eth.getAccounts();
        this.setState({ account: accounts[0] });

        // setup the contract
        const gameContractAddress = '0x2bdDD797FB8dFEfFcf3363481D8f2d861535549c';//'0x2bdDD797FB8dFEfFcf3363481D8f2d861535549c'; 
        const gameContractABI = require('./contractABI.json');
        const gameContract = new web3.eth.Contract(gameContractABI, gameContractAddress);
        const gameStarted = await gameContract.methods.gameStarted().call(); 
        this.setState({ contract: gameContract });

        // get data from the contract
        const costPerEntry = await gameContract.methods.costPerEntry().call();
        const maxAllowedEntries = await gameContract.methods.maxAllowedEntries().call();
        const currentEntries = await gameContract.methods.numberOfCurrentEntries().call(); 

        if (this.state.costPerEntry !== costPerEntry) {
              this.setState({ 
                  costPerEntry, 
                  maxAllowedEntries, 
                  currentEntries, 
                  amount: Web3.utils.fromWei(costPerEntry, 'ether'),
                  gameStarted, 
              });
          } else {
              this.setState({ 
                  costPerEntry, 
                  maxAllowedEntries, 
                  currentEntries,
                  gameStarted,
              });
          }
        }

    handleInputChange = (e) => {
        if (/^(\d+(\.\d*)?|\.\d+)?$/.test(e.target.value)) {
            this.setState({ amount: e.target.value });
        } else {
            window.alert('Please enter numbers only!');
        }
    }

    handleBlur = (e) => {
        const enteredAmount = new BigNumber(e.target.value);
        const costPerEntryEther = new BigNumber(Web3.utils.fromWei(this.state.costPerEntry, 'ether'));

        if (enteredAmount.isLessThanOrEqualTo(0)) {
            window.alert('Negative amount or zero not allowed!');
            this.setState({ amount: costPerEntryEther.toString() });
            return;
        }

        if (enteredAmount.mod(costPerEntryEther).comparedTo(0) !== 0) {
            window.alert(`Entered amount should be multiple of ${costPerEntryEther.toString()}!`);
            this.setState({ amount: costPerEntryEther.toString() });
            return;
        }

        const userEntryCount = enteredAmount.dividedBy(costPerEntryEther);

        if (userEntryCount.plus(new BigNumber(this.state.currentEntries)).isGreaterThan(this.state.maxAllowedEntries)) {
            window.alert('Over max entries limit');
            this.setState({ amount: costPerEntryEther.toString() });
            return;
        }

        this.setState({ amount: enteredAmount.toString() });
    }

    incrementAmount = () => {
        const costPerEntryEther = new BigNumber(Web3.utils.fromWei(this.state.costPerEntry, 'ether'));
        const incrementedAmount = new BigNumber(this.state.amount).plus(costPerEntryEther);
        const userEntryCount = incrementedAmount.dividedBy(costPerEntryEther);

        if (userEntryCount.plus(new BigNumber(this.state.currentEntries)).isGreaterThan(this.state.maxAllowedEntries)) {
            window.alert('Over max entries limit');
            return;
        }

        this.setState({ amount: incrementedAmount.toString() });
    }


    decrementAmount = () => {
    let amount = new BigNumber(this.state.amount).minus(new BigNumber(Web3.utils.fromWei(this.state.costPerEntry, 'ether'))).toString();
        if (new BigNumber(amount).isLessThanOrEqualTo(0)) {
            window.alert('Negative amount or zero not allowed!');
        } else {
            this.setState({ amount });
        }
    }

    onEnterGame = async () => {
    const { contract, amount } = this.state;
    const { account } = this.props; // using props instead of state

    if (!account) {
        window.alert('Please connect your wallet before entering the game.');
        return;
    }

    try {
        // Add the additional checks for game eligibility
        const gameStarted = await contract.methods.gameStarted().call();
        const maxAllowedEntries = await contract.methods.maxAllowedEntries().call();
        const numberOfCurrentEntries = await contract.methods.numberOfCurrentEntries().call();

        if (gameStarted !== '1' || numberOfCurrentEntries === maxAllowedEntries) {
            window.alert('Game not started');
            return;
        }

        console.log('Sending transaction');
        await contract.methods.enterGame().send({ 
            value: Web3.utils.toWei(amount, 'ether'), 
            from: account 
        });
        console.log('Transaction sent');
    } catch (err) {
        console.error(err);
    }
}


    render() {
    const { gameStarted, amount, currentEntries, maxAllowedEntries } = this.state;
    if (gameStarted != "1") {
        return null;
    }
    if (gameStarted == "1" && currentEntries == maxAllowedEntries){
        return(
            <div className="enterBox" style={{ backgroundColor: 'red', color: 'white',width: 'auto', height: 'auto', fontSize: '3vw', padding: '1vw', fontWeight: 'bold' }}>
                        Game Ended! Picking Winners In Progress
                    </div>
            )
    }
    return (
        <div className ="enterBox" style={{ width: 'auto', height: 'auto', padding: '10px' }}>
            <div style={{ textAlign: 'center' }}>
                <button 
                    onClick={this.decrementAmount} 
                    style={{
                        fontSize: '2vw', 
                        fontWeight: 'bold', 
                        border: '2px ', 
                        marginRight: '10px', 
                        backgroundColor: '#fdffe3',
                        width: '8%', 
                        height:'40%',
                        boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                        borderRadius: '15px', // round the corners a bit for a better 3D effect
                        transition: 'all 0.5s ease', // transition effect for the button when pressed
                    }}
                    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                    onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                    onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                >-</button>
                
                <input 
                    type="text"
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur} 
                    value={amount} 
                    style={{ 
                        color: 'black', 
                        backgroundColor: '#fdffe3',
                        border: '10px', 
                        width: '57%', 
                        height: '40%', 
                        textAlign: 'center', 
                        fontSize: '2vw',
                        fontWeight: 'bold',
                        marginTop: '20px',
                        borderRadius: '15px'
                    }} 
                />
                <button 
                    onClick={this.incrementAmount} 
                    style={{
                        fontSize: '2vw', 
                        fontWeight: 'bold', 
                        border: '2px', 
                        marginLeft: '10px', 
                        backgroundColor: '#fdffe3',
                        color: '#000000',
                        borderColor: 'ffdf52',
                        width: '8%', 
                        height:'40%',
                        boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                        borderRadius: '15px', // round the corners a bit for a better 3D effect
                        transition: 'all 0.5s ease', // transition effect for the button when pressed
                    }}
                    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                    onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                    onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
                >+</button>

                <button 
                onClick={this.onEnterGame} 
                style={{ 
                    display: 'block', 
                    color: 'white', 
                    backgroundColor: '#53c984', 
                    marginTop: '10px', 
                    marginBottom: '20px',
                    marginLeft:'auto',
                    marginRight: 'auto',
                    width: '75%', 
                    height: 'auto',
                    padding: '1px',
                    fontSize: '2vw',
                    fontWeight: 'bold',
                    border: '1px',
                    boxShadow: '0px 5px 15px rgba(0,0,0,0.3)', // adds a soft shadow to give a lifting effect
                    borderRadius: '15px', // round the corners a bit for a better 3D effect
                    transition: 'all 0.3s ease', // transition effect for the button when pressed
                }}
                onMouseDown={e => e.currentTarget.style.transform = 'scale(0.95)'} // reduce size a bit when pressed
                onMouseUp={e => e.currentTarget.style.transform = ''} // return to original size when released
                onMouseLeave={e => e.currentTarget.style.transform = ''} // return to original size when mouse leaves
            >ENTER GAME</button>

                
            </div>
        </div>
    );
}

}

export default EnterGame;
